import { render, staticRenderFns } from "./LegalParameterList.vue?vue&type=template&id=0af85704"
import script from "./LegalParameterList.vue?vue&type=script&lang=js"
export * from "./LegalParameterList.vue?vue&type=script&lang=js"
import style0 from "./LegalParameterList.vue?vue&type=style&index=0&id=0af85704&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports